import { makeRequest } from 'utils/requestLogger';

export default (poll_id) =>
    makeRequest('get', `/api/polls/${poll_id}`);


// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/getPoll.js